/**
 * ProductAndRecipeCardLayoutSettings['MobileDisplayOption']
 */
export var MobileDisplayOption;
(function (MobileDisplayOption) {
    MobileDisplayOption[MobileDisplayOption["TitleOnly"] = 0] = "TitleOnly";
    MobileDisplayOption[MobileDisplayOption["SymbolFlags"] = 10] = "SymbolFlags";
    MobileDisplayOption[MobileDisplayOption["Description"] = 20] = "Description";
    MobileDisplayOption[MobileDisplayOption["RecipeTypes"] = 30] = "RecipeTypes";
})(MobileDisplayOption || (MobileDisplayOption = {}));
